export default function OurValues() {
  const values = [
    {
      icon: 'ri-award-line',
      title: 'Quality',
      description: 'We deliver craftsmanship that stands the test of time.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Safety',
      description: 'Every team member goes home safe, every day.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Integrity',
      description: 'We do what we say, on budget and on schedule.'
    },
    {
      icon: 'ri-team-line',
      title: 'Partnership',
      description: 'We build lasting relationships with owners, investors, and contractors.'
    }
  ];

  return (
    <section className="py-20 bg-[#2B2B2B]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#C5A55A] mb-16 text-center">
          Our Values
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
                <i className={`${value.icon} text-5xl text-[#C5A55A]`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">
                {value.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}